import React from 'react'
import {Form, Icon, Input, Checkbox, Radio, Select} from 'antd';

import PatientElectronicText from './Texts/PatientElectronicText';
import SurrogateElectronicText from './Texts/SurrogateElectronicText';
import Signature from "./Signature";

const { Option } = Select;

export default class extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const props = this.props;

    const isEmail = props.consentMethodType === 'Email';
    const showForEmail = !(props.consentMethodType === 'Email' && !props.token);

    return (
      <div className="form-group">
        <h4>{props.consentPersonType === 'Surrogate' ? 'Consent Process - Surrogate' : 'Consent Process - Patient'}</h4>

        <div className="form-group-details">
          {props.siteID && <h5>Site ID: <b>{props.siteID}</b></h5>}
          {props.userID && <h5>User ID: <b>{props.userID}</b></h5>}
          <h5>Subject ID: <b>{props.subjectID}</b></h5>
        </div>

        {props.consentPersonType === 'Surrogate' ? <SurrogateElectronicText {...props} /> :
          <PatientElectronicText {...props} />}

        <p><strong>Server Date (UTC): {props.date || props.consentDate}</strong></p>
        <p><strong>Consent Type: {props.consentPersonType}</strong></p>
        <p><strong>Consent Method: {props.consentMethodType}</strong></p>
        <p>&nbsp;</p>

        <h4>CONSENT</h4>

        <div style={{ textAlign: 'left' }}>

          {showForEmail && <div>
            <p>You are providing consent to stay in the study for ongoing data collection. The administration of either Alteplase or Tenecteplase cannot be undone. If you decide not to consent, data collected up until this point will be retained. You will not be contacted in future. You may also withdraw consent for further contact but continue follow-up via health record linkage.</p>
            <Form.Item>
              <label>
                <div className='form-label'>Please check the appropriate box to indicate your decision:</div>
                {props.form.getFieldDecorator('sb_dic_consent_option', {
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Radio.Group>
                    <Radio value='stay_in_study'>
                      I wish to stay in the study.
                    </Radio>
                    <br/>
                    <Radio value='withdraw_from_study'>
                      I wish to withdraw from the study
                    </Radio>
                    <br/>
                    <Radio value='withdraw_from_study_allow_data_collection_via_linkage'>
                      I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage.
                    </Radio>
                  </Radio.Group>
                )}
              </label>
            </Form.Item>

            <p>You may withdraw your participation at any time without giving reasons. Withdrawing from further participation has no effect on how you will be treated by the doctors currently providing care. If you choose to participate and then decide to withdraw at a later time, all data collected prior to your withdrawal of consent will be retained for the database. It is a legal requirement that these data cannot be destroyed for Health Canada regulated research only.</p>
          </div>}
          <br/><br/>

          <h4>SIGNATURES</h4>
          <div>
            <p>
              Your signature on this form indicates that you have understood to your satisfaction the information regarding your participation in the research project and agree to participate as a subject. In no way does this waive your legal rights nor release the investigators, or involved institutions from their legal and professional responsibilities. You are free to withdraw from the study at any time without jeopardizing your health care. If you have further questions concerning matters related to this research, please contact:
            </p>
            <p>Site PI: Dr. George Medvedev 604-759-2140</p>
            <p>Study Coordinator: Vishaya Naidoo 778-865-4586</p>
            <p>If you have any questions concerning your rights as a possible participant in this research, or research in general, please contact the Fraser Health Research Ethics Board co-Chair by calling 604-587-4681.</p>
            <br/><br/>
          </div>


          <Form.Item>
            <label>
              <div className='form-label'>Participant’s Name</div>
              {props.form.getFieldDecorator('sb_dic_research_subject_name', {
                initialValue: props.sb_dic_research_subject_name,
                rules: [{
                  required: false,
                  message: 'Required'
                }],
              })(
                <Input
                  prefix={<Icon type="user" style={{color: '#eee'}}/>}
                  placeholder="Participant’s Name"
                />
              )}
            </label>
          </Form.Item>

          {props.consentMethodType === 'Email' && props.consentPersonType === 'Surrogate' &&
          <Form.Item>
            <label>
              <div className='form-label'>Substitute Decision Maker</div>
                {props.form.getFieldDecorator('sb_dic_participant_email', {
                  initialValue: props.sb_dic_participant_email,
                  rules: [{required: true, message: 'Please enter the SDM\'s email'}, {type: 'email'}],
                })(
                  <Input disabled={props.token} placeholder="Substitute Decision Maker Email"/>
                )}
            </label>
          </Form.Item>}
          {props.consentMethodType === 'Email' && props.consentPersonType === 'Patient' &&
          <Form.Item>
            <label>
              <div className='form-label'>Participant Email</div>
                {props.form.getFieldDecorator('sb_dic_participant_email', {
                  initialValue: props.sb_dic_participant_email,
                  rules: [{required: true, message: 'Please enter the participant\'s email'}, {type: 'email'}],
                })(
                  <Input disabled={props.token} placeholder="Participant Email"/>
                )}
            </label>
          </Form.Item>}

          {!props.token && (
            <div>
              <p>Incapacitated participants who have the capability of understanding their diagnosis and consequences of the diagnosis have had the study and treatment explained to them, in the presence of their authorized representative or an impartial witness. Consent, was obtained from the authorized representative and verbal assent was obtained from the incapacitated participant.</p>
              <Form.Item>
                <label>
                  {props.form.getFieldDecorator('assent_not_applicable', {
                    initialValue: false,
                    valuePropName: 'checked'
                  })(<Checkbox>Assent not applicable</Checkbox>)}
                </label>
              </Form.Item>


              <Form.Item>
                <label>
                  {props.form.getFieldDecorator('assent_verbally_obtained', {
                    initialValue: false,
                    valuePropName: 'checked'
                  })(<Checkbox>Assent verbally obtained</Checkbox>)}
                </label>
              </Form.Item>
            </div>
          )}

          {props.consentPersonType === 'Patient' && showForEmail && !(props.form.getFieldValue('assent_not_applicable') || props.form.getFieldValue('assent_verbally_obtained'))  && (
            <div>
              <Signature fieldName='sb_dic_research_subject_signature' label='Signature of Participant' form={props.form} />
            </div>
          )}

          {props.consentPersonType === 'Surrogate' && <div>
            {!props.form.getFieldValue('sb_dic_surrogate_name_not_applicable') && <Form.Item>
              <label>
                <div className='form-label'>Authorized Representative Name</div>
                {props.form.getFieldDecorator('sb_dic_surrogate_name', {
                  initialValue: props.sb_dic_surrogate_name,
                  rules: [{
                    message: 'Required'
                  }],
                })(
                  <Input
                    prefix={<Icon type="user" style={{color: '#eee'}}/>}
                    placeholder="Authorized Representative Name"
                  />
                )}
              </label>
            </Form.Item>}
            <Form.Item>
              <label>
                {props.form.getFieldDecorator('sb_dic_surrogate_name_not_applicable', {
                  initialValue: false,
                  valuePropName: 'checked'
                })(<Checkbox>Authorized Representative Name is Not applicable</Checkbox>)}
              </label>
            </Form.Item>

            <Form.Item>
              <label>
                <div className='form-label'>Authorized Representative Relationship to Participant</div>
                {props.form.getFieldDecorator('kw_representative_relationship_to_participant', {
                  initialValue: props.kw_representative_relationship_to_participant,
                })(
                  <Input
                    prefix={<Icon type="user" style={{color: '#eee'}}/>}
                    placeholder="Authorized Representative Relationship to Participant"
                  />
                )}
              </label>
            </Form.Item>

            {showForEmail && !(props.form.getFieldValue('assent_not_applicable') || props.form.getFieldValue('assent_verbally_obtained')) && <Signature fieldName='sb_dic_surrogate_signature' label='Signature of Authorized Representative' form={props.form} />}

            <p>
              <i>
                *An authorized representative in this study is the person who has the authority to make a decision about participation in the study on behalf of a participant who does not have the capacity to decide, as the participant’s parent or guardian or as someone who was entrusted by the participant to make such decision when the participant was competent. The authorized representative should make decisions according to the participant’s wishes and best interests.
              </i>
            </p>
          </div>}


          <div>
            <Form.Item>
              <label>
                <div className='form-label'>Person Obtaining Consent Name</div>
                {props.form.getFieldDecorator('sb_dic_investigator_name_and_role', {
                  initialValue: props.sb_dic_investigator_name_and_role,
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Input
                    disabled={props.token}
                    prefix={<Icon type="user" style={{color: '#eee'}}/>}
                    placeholder="Name & Role"
                  />
                )}
              </label>
            </Form.Item>

            {!props.token && <Signature fieldName='sb_dic_investigator_signature' label='Person Obtaining Consent Name Signature' form={props.form} />}
          </div>

          {!props.token && !isEmail && <div>
            <div>
              <h4>Impartial Witness</h4>
              <p>This section is required only if the participant (or their authorized representative, as applicable) is unable to read or unable to write, or if remote consent is obtained from the Authorized Representative. An impartial witness may also be used in any other circumstance where the study personnel feel it would be beneficial.</p>
              <p>The consent form was accurately explained to, and apparently understood by, the participant (or their authorized representative as applicable), and consent was freely given by the participant (or authorized representative as applicable).</p>

              <Form.Item>
                <label>
                  <div className='form-label'>Impartial Witness</div>
                  {props.form.getFieldDecorator('sb_dic_witness_name', {
                    initialValue: props.sb_dic_witness_name,
                  })(
                    <Input
                      prefix={<Icon type="user" style={{color: '#eee'}}/>}
                      placeholder="Witness Name"
                    />
                  )}
                </label>
              </Form.Item>

              {props.form.getFieldValue('sb_dic_witness_name') && <Signature fieldName='sb_dic_witness_signature' label='Signature of Witness' form={props.form} optional={false} />}

              <p>
                <i>**Impartial Witness: A person, who is independent of the trial, who cannot be unfairly influenced by people involved with the trial, who attends the consent process if the participant or the participant’s authorized representative cannot read/write, in the case of remote consent, or for any other reason where the study staff feels it is appropriate, and who reads the consent and any other written information supplied to the participant.</i>
              </p>
            </div>
          </div>}


          {showForEmail && <div>
            <h4>Contact Information for Study Results</h4>
            <p>To receive notification of the outcome of this study from the hospital and/or research site, please provide your name, as well as at least one of the following: mailing address, email address or phone number.</p>
            <Form.Item>
              <label>
                <div className='form-label'>Mailing Address:</div>
                {props.form.getFieldDecorator('consent_participant_address', {
                  initialValue: props.consent_participant_address,
                  rules: [{
                    required: !(props.form.getFieldValue('consent_participant_phone') || props.form.getFieldValue('consent_participant_email')),
                    message: 'Required'
                  }]
                })(
                  <Input
                    prefix={<Icon type="user" style={{color: '#eee'}}/>}
                    placeholder="Mailing Address"
                  />
                )}
              </label>
            </Form.Item>
            <Form.Item>
              <label>
                <div className='form-label'>Email address:</div>
                {props.form.getFieldDecorator('consent_participant_email', {
                  initialValue: props.consent_participant_email,
                  rules: [{
                    required: !(props.form.getFieldValue('consent_participant_phone') || props.form.getFieldValue('consent_participant_address')),
                    message: 'Required'
                  }]
                })(
                  <Input
                    prefix={<Icon type="user" style={{color: '#eee'}}/>}
                    placeholder="Email address"
                  />
                )}
              </label>
            </Form.Item>
            <Form.Item>
              <label>
                <div className='form-label'>Phone number:</div>
                {props.form.getFieldDecorator('consent_participant_phone', {
                  initialValue: props.consent_participant_phone,
                  rules: [{
                    required: !(props.form.getFieldValue('consent_participant_address') || props.form.getFieldValue('consent_participant_email')),
                    message: 'Required'
                  }]
                })(
                  <Input
                    prefix={<Icon type="user" style={{color: '#eee'}}/>}
                    placeholder="Phone number"
                  />
                )}
              </label>
            </Form.Item>
          </div>}

          {showForEmail && <div>
            <Form.Item>
              <label>
                <div className='form-label'>Do you consent to the terms described above?</div>
                {props.form.getFieldDecorator('consent_provided', {
                  initialValue: props.consent_provided,
                  rules: [{
                    required: true,
                    message: 'Do you consent to the terms described above?'
                  }],
                })(
                  <Select>
                    <Option value="yes">Yes</Option>
                    <Option value="">No</Option>
                  </Select>
                )}
              </label>
            </Form.Item>
          </div>}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ConsentTypeRoyalUniversity/Step3aPatient.js